export class ModalRestorePass {
	constructor(selector) {
		this.$container = selector;
		if (!this.$container) return;
		this.init();
	}

	init() {
		this.resetStartAnimation();

		this.restoreForm = this.$container.querySelector('.js-modal-restore-form');
		this.restoreForm && this.restoreForm.addEventListener('submit', this.submitHander.bind(this));
	}

	resetStartAnimation() {
		setTimeout(() => {
			this.$container.classList.remove('hidden');
		}, 2000);
	}

	submitHander(event) {
		event.preventDefault();

		this.$container.dispatchEvent(
			new CustomEvent('sendLinkToEmail', {
				detail: {
					data: new FormData(this.restoreForm),
				},
			}),
		);
	}
}
